import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { TASK_FORM_ID } from '@wdx/shared/utils';
import { ICON_ADD } from '../../constants/icons.constants';
import { ActionButton } from '../../models/action-button.model';
import { ActionButtonMode } from '../../models/action-buttons-mode.model';
import { Privilege } from '../../models/privilege.model';

export const TASK_DATA = {
    viewType: SystemEntity.Task,
    searchPlaceholder: 'Search',
    searchTypePlural: '',
    searchType: '',
};

export const ADD_TASK_ACTION_BTN: ActionButton = {
    mode: ActionButtonMode.IconButton,
    icon: ICON_ADD.icon,
    formSetup: {
        formId: TASK_FORM_ID,
        initialisationParams: {},
    },
    cySelector: 'btn-add-tasks',
    privileges: [Privilege.CreateActivity],
};
